import React from 'react'
import TestimonialCreate from '../testimonial_components/testimonial_create'

export default function TestimonialCreatePage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <TestimonialCreate />
    </div>
  )
}
